// extracted by mini-css-extract-plugin
module.exports = {"WhatWeDo":"WhatWeDo_WhatWeDo__SeoEr","List":"WhatWeDo_List__1IepN","ListItem":"WhatWeDo_ListItem__2sOkz"};